import React, { memo } from 'react';

import { Tooltip } from 'antd';

import { InfoCircleOutlined } from '@ant-design/icons';

import { useTheme } from '../../../../context/ThemeProvider';

interface Props {
  label: React.ReactNode;
  info?: React.ReactNode;
}

const FormItemLabel: React.FC<Props> = ({ label, info }) => {
  const { colors: COLORS } = useTheme();

  return (
    <>
      {label}

      {info ? (
        <Tooltip title={info}>
          <InfoCircleOutlined
            style={{ marginLeft: 6, color: COLORS.ICON, cursor: 'help' }}
          />
        </Tooltip>
      ) : null}
    </>
  );
};

export default memo(FormItemLabel);
